// components/pages/HomePage.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  text-align: center;
`;

const Title = styled.h1`
  font-size: 2.5rem;
  margin-bottom: 1.5rem;
`;

const Description = styled.p`
  font-size: 1.2rem;
  margin-bottom: 2rem;
  color: #555;
`;

const Button = styled(Link)`
  display: inline-block;
  background-color: #007bff;
  color: white;
  padding: 0.75rem 1.5rem;
  text-decoration: none;
  border-radius: 4px;
  font-weight: 500;
  
  &:hover {
    background-color: #0069d9;
  }
`;

const PortalLink = styled(Link)`
  display: block;
  margin-top: 2rem;
  color: #666;
  
  &:hover {
    text-decoration: underline;
  }
`;

const HomePage: React.FC = () => {
  return (
    <Container>
      <Title>DNA Atlas</Title>
      <Description>
        Welcome to DNA Atlas - Your interactive map visualization platform
      </Description>
      <Button to="/menu">Explore Map Options</Button>
      <PortalLink to="/portal/maps">Internal Portal</PortalLink>
    </Container>
  );
};

export default HomePage;